/* dev-inspector — inspector de líneas para stacks HTML/CSS/JS vanilla (AndrhUX).
 *
 * Uso: mantén OPT/Alt → se resalta el elemento bajo el cursor con "archivo:línea".
 *      Alt+click → copia la referencia al portapapeles, ej:
 *      [site/admin.html:551 · #clientTitle · "Daneli's Cleaning"]
 *      Pégala en el chat de Claude junto con tu comentario de qué cambiar.
 *
 * Instalación por página (el tag dice qué archivo fuente es):
 *   <script src="/_system/dev-inspector.js" data-file="site/admin.html" defer></script>
 *
 * Solo se activa en hosts locales — en producción es un no-op total.
 * Elementos generados por JS no existen en el HTML fuente: se reporta el contenedor
 * con id más cercano y se marca "(generado por JS)".
 */
(function () {
  'use strict';
  if (!/^(localhost|127\.0\.0\.1|0\.0\.0\.0|\[::1\])$/.test(location.hostname)) return;

  var ownScript = document.currentScript || document.querySelector('script[src*="dev-inspector"]');
  var FILE = (ownScript && ownScript.getAttribute('data-file')) || location.pathname;

  var srcLines = null;
  function loadSource() {
    if (srcLines) return Promise.resolve(srcLines);
    return fetch(location.href, { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { srcLines = t.split('\n'); return srcLines; })
      .catch(function () { srcLines = []; return srcLines; });
  }

  function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function lineOf(re) {
    for (var i = 0; i < srcLines.length; i++) if (re.test(srcLines[i])) return i + 1;
    return 0;
  }

  // Localiza la línea del elemento en el fuente: id propio → texto único → ancestro con id.
  function locate(el) {
    if (el.id) {
      var ln = lineOf(new RegExp('id="' + escRe(el.id) + '"'));
      if (ln) return { line: ln, sel: '#' + el.id, generated: false };
    }
    var text = (el.textContent || '').trim();
    if (text.length >= 3 && text.length <= 60 && el.children.length === 0) {
      var matches = 0, found = 0;
      var tre = new RegExp(escRe(text));
      for (var i = 0; i < srcLines.length; i++) {
        if (tre.test(srcLines[i])) { matches++; if (!found) found = i + 1; }
      }
      if (matches === 1) return { line: found, sel: cssPath(el), generated: false };
    }
    var anc = el.closest('[id]');
    if (anc && anc !== el) {
      var aln = lineOf(new RegExp('id="' + escRe(anc.id) + '"'));
      if (aln) return { line: aln, sel: '#' + anc.id + ' → ' + cssPath(el), generated: true };
    }
    return { line: 0, sel: cssPath(el), generated: true };
  }

  function cssPath(el) {
    var tag = el.tagName.toLowerCase();
    var cls = el.classList.length ? '.' + Array.prototype.slice.call(el.classList, 0, 2).join('.') : '';
    return tag + cls;
  }

  function refString(el) {
    var loc = locate(el);
    var text = (el.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 40);
    var parts = [FILE + (loc.line ? ':' + loc.line : ''), loc.sel];
    if (text) parts.push('"' + text + '"');
    if (loc.generated) parts.push('(generado por JS)');
    return '[' + parts.join(' · ') + ']';
  }

  /* ---------- UI ---------- */
  var box, tip, toast, active = false, current = null;
  function ensureUi() {
    if (box) return;
    box = document.createElement('div');
    box.style.cssText = 'position:fixed;z-index:99998;pointer-events:none;border:1.5px solid #FF4D00;background:rgba(255,77,0,.08);border-radius:4px;transition:all .06s linear';
    tip = document.createElement('div');
    tip.style.cssText = 'position:fixed;z-index:99999;pointer-events:none;background:#111;color:#F5F5F5;border:1px solid #333;border-radius:6px;padding:5px 9px;font:11px/1.4 "IBM Plex Mono",monospace;max-width:70vw;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;box-shadow:0 4px 14px rgba(0,0,0,.5)';
    toast = document.createElement('div');
    toast.style.cssText = 'position:fixed;z-index:99999;left:50%;bottom:28px;transform:translateX(-50%);background:#FF4D00;color:#fff;border-radius:999px;padding:8px 18px;font:12px "IBM Plex Mono",monospace;display:none';
    document.body.appendChild(box); document.body.appendChild(tip); document.body.appendChild(toast);
  }
  function hideUi() {
    if (box) { box.style.display = 'none'; tip.style.display = 'none'; }
    current = null;
  }
  function highlight(el, x, y) {
    ensureUi();
    var r = el.getBoundingClientRect();
    box.style.display = 'block';
    box.style.left = r.left - 2 + 'px'; box.style.top = r.top - 2 + 'px';
    box.style.width = r.width + 2 + 'px'; box.style.height = r.height + 2 + 'px';
    tip.style.display = 'block';
    tip.textContent = refString(el);
    var ty = y + 18, tx = Math.min(x + 12, innerWidth - 320);
    if (ty > innerHeight - 46) ty = y - 34;
    tip.style.left = tx + 'px'; tip.style.top = ty + 'px';
  }
  function showToast(msg) {
    ensureUi();
    toast.textContent = msg; toast.style.display = 'block';
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.style.display = 'none'; }, 1400);
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // fallback (0.0.0.0 no es secure context)
    var ta = document.createElement('textarea');
    ta.value = text; ta.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) { /* nada */ }
    document.body.removeChild(ta);
    return Promise.resolve();
  }

  /* ---------- Eventos ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Alt' && !active) { active = true; loadSource(); }
  });
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Alt') { active = false; hideUi(); }
  });
  window.addEventListener('blur', function () { active = false; hideUi(); });
  document.addEventListener('mousemove', function (e) {
    if (!active || !srcLines) return;
    var el = document.elementFromPoint(e.clientX, e.clientY);
    if (!el || el === box || el === tip || el === document.body || el === document.documentElement) { hideUi(); return; }
    current = el;
    highlight(el, e.clientX, e.clientY);
  }, true);
  document.addEventListener('click', function (e) {
    if (!e.altKey || !current) return;
    e.preventDefault(); e.stopPropagation();
    var ref = refString(current);
    copy(ref).then(function () { showToast('Copiado — pégalo en el chat'); });
  }, true);

  console.log('[dev-inspector] activo — mantén OPT/Alt y haz Alt+click para copiar la referencia');
})();
